var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    viewBox: "0 0 24 14",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.7477 12.8585 10.9671-11.03182c.1831-.18407.2852-.42862.2852-.68293 0-.254309-.1021-.498858-.2852-.68293l-.0124-.011878c-.0888-.089543-.1956-.160845-.314-.209568s-.2459-.073848-.3748-.073848-.2564.025125-.3748.073848c-.1184.048724-.2253.120025-.314.209568l-10.3269 10.388458-10.32269-10.388456c-.08875-.089543-.19559-.160845-.314-.209568s-.24593-.073849-.374797-.073849c-.128864 0-.256382.025126-.374796.073849s-.225248.120025-.314005.209568l-.012392.011878c-.183084.184072-.28521917.428622-.28521914.682928.00000002.25431.10213514.49886.28521914.68294l10.96708 11.03181c.0965.097.2125.1743.341.227.1285.0528.2669.08.4067.08s.2782-.0272.4067-.08c.1285-.0527.2445-.13.341-.227z",
    fill: "#8d8d8d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.20b0b60c556f2697da9ada6a97c8efa1.svg";
export { ForwardRef as ReactComponent };